import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "lacontadina_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] bg-ink text-cream/90 border border-gold/30 shadow-2xl p-5">
      <div className="flex gap-3">
        <Cookie className="text-gold shrink-0 mt-1" size={22} strokeWidth={1.4} />
        <div>
          <p className="text-sm font-light leading-relaxed">
            Wir verwenden Cookies, um die Website bestmöglich zu gestalten. Details in unserer{" "}
            <Link to="/datenschutz" className="text-gold underline hover:text-gold-dark">Datenschutzerklärung</Link>.
          </p>
          <div className="flex gap-3 mt-4">
            <button data-testid="cookie-accept" onClick={accept} className="btn-pop bg-gold text-ink px-5 py-2 text-xs uppercase tracking-[0.15em]">Akzeptieren</button>
            <Link to="/datenschutz" className="px-5 py-2 text-xs uppercase tracking-[0.15em] text-cream/70 hover:text-cream self-center">Mehr erfahren</Link>
          </div>
        </div>
      </div>
    </div>
  );
};
